<template lang='pug'>
  .horizontal-product-card
    hr
    .row
      .col-md-4.col-lg-3.variant-image
        router-link(
          :to='{ name: "products-show-variant", params: { id: product.attributes["slug-url"], variantId: variant.attributes["slug-url"] } }'
          :target='isMobile ? undefined : "_blank"'
          :rel='isMobile ? undefined : "noopener"'
        )
          img(
            :src='variant.attributes["closeup-image-urls"][0]'
            :alt='`${product.attributes.name} ${variant.attributes.name}`'
          )
      .col-md-5.col-lg-7.col-sm-12.product-details
        p.product-new-arrival(
          v-if='variant.attributes["new-arrival"]'
          v-t='"common.new"'
        )
        p.product-brand
          router-link(
            :to='{ name: "brands-show", params: { id: variant.attributes["brand-slug-url"] } }'
            v-text='variant.attributes["brand-name"]'
            :target='isMobile ? undefined : "_blank"'
            :rel='isMobile ? undefined : "noopener"'
          )
        p.product-name(v-text='product.attributes.name')
        p.variant-name(
          v-if='product.attributes["variants-count"] > 1'
          v-text='variant.attributes.name'
        )
        ProductPrice(
          :variant='variant'
          :showOffWord='true'
        )
        ProductVariantsCount(:product='product')
        .product-description
          p
            b(v-text='`${$t("products.whatItDoes")}:`')
          ExpandableText(
            :content='product.attributes.description'
            :maxHeight='maxHeightDescription'
          )
        .product-review
          ProductRating(
            :product='product'
            :reviews-count='product.attributes["reviews-count"]'
            :shouldScrollToReviews='false'
            :openLinkInNewTab='isMobile ? false : true'
          )
          p.review-title
            b(v-text='`${review.attributes.name} - ${review.attributes.title}`')
          .review-text
            ExpandableText(
              :content='review.attributes.text'
              :maxHeight='maxHeightReview'
            )
      .col-md-3.col-lg-2.col-sm-12.product-actions
        .action-button-wrapper
          ProductCallToAction(
            :product='product'
            :variant='variant'
          )
          router-link.btn.btn-white.btn-block.view-product(
            :to='{ name: "products-show-variant", params: { id: product.attributes["slug-url"], variantId: variant.attributes["slug-url"] } }'
            v-t='"buttons.viewDetails"'
            :target='isMobile ? undefined : "_blank"'
            :rel='isMobile ? undefined : "noopener"'
          )
</template>

<script>
import ProductRating from '@/components/products/product-rating.vue'
import ProductCallToAction from '@/components/products/product-call-to-action.vue'
import ExpandableText from '@/components/shared/expandable-text.vue'
import ProductPrice from '@/components/products/product-price.vue'
import ProductVariantsCount from '@/components/products/product-variants-count.vue'

export default {
  name: 'HorizontalProductCard',

  components: {
    ProductRating,
    ProductCallToAction,
    ExpandableText,
    ProductPrice,
    ProductVariantsCount
  },

  props: {
    product: {
      type: Object,
      required: true
    },
    variant: {
      type: Object,
      required: true
    },
    review: {
      type: Object,
      required: true
    }
  },

  computed: {
    isMobile: () => vueSupport.isMobile,
    maxHeightReview () {
      return this.isMobile ? 80 : 50
    },
    maxHeightDescription () {
      return this.isMobile ? 50 : 35
    }
  }
}
</script>

<style lang='scss' scoped>
  .horizontal-product-card {
    hr {
      border: 0;
      height: 0;
      border-bottom: 1px solid $grey;
    }
    .row {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
  .variant-image {
    text-align: center;

    img {
      width: 100%;
      max-width: 250px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .product-details {
    & > * {
      max-width: 620px;
      margin-bottom: 5px;
    }

    .product-new-arrival {
      @include font-weight-bold;
      color: $brand-primary;
      letter-spacing: 2px;
      text-transform: uppercase;
      font-size: 12px;
    }

    .product-name, .variant-name {
      font-size: 16px;
    }

    .product-brand {
      @include font-weight-bold;
      text-transform: uppercase;
      font-size: 20px;
    }

    .product-price {
      @include font-weight-bold;
      font-size: 16px;
    }

    .product-description {
      margin-top: 15px;

      p {
        margin-bottom: 5px;
      }

      li {
        list-style: disc;
        margin-left: 25px;
        margin-bottom: 5px;
        padding-left: 10px;
      }
    }

    .product-review {
      margin-top: 15px;
    }
  }

  .product-actions {
    div.product-call-to-action {
      width: 100%;
    }
    .btn.view-product {
      display: inline-block;
      margin-top: 20px;
      width: 100%;
    }

    @include media-breakpoint-down(sm) {
      div.product-call-to-action {
        width: 140px;
        margin-right: 20px;
        margin-top: 27px;
      }
      .btn.view-product {
        display: inline-block;
        width: 140px;
        margin-top: 27px;
      }
      .action-button-wrapper {
        width: 300px;
        margin-right: auto;
        margin-left: auto;
      }
    }
  }
</style>
<style lang='scss'>
  .horizontal-product-card {
    .rating-container .product-rating-count {
      margin-bottom: 5px;
    }

    @include media-breakpoint-down(sm) {
      .rating-container {
        margin-bottom: 16px;
      }
    }
  }
</style>
